export const isValid = (number) => {
  return /^\d+(\.\d{1,9})?$/.test(number);
};

export const checkDefaultNum = (number) => {
  return isValid(number) ? number : 0;
};

export const checkNumNA = (number) => {
  return isValid(number) ? number : 'N/A';
};

/**
 * 两数相加
 * @param {number} num1
 * @param {number} num2
 * @returns {number}
 */
export const addNumber = (num1, num2) => {
  return checkDefaultNum(num1) + checkDefaultNum(num2);
};

/**
 * 两数相除
 */
export const divideNumber = (num1, num2) => {
  console.log(num1, num2);
  if (!isValid(num2)) {
    return '';
  }
  return num1 / num2;
};

/**
 * 两数相除百分比
 */
export const divideNumberPercent = (num1, num2) => {
  num1 = checkDefaultNum(num1);
  num2 = checkDefaultNum(num2);
  if (num2 === 0) {
    return 'N/A';
  }
  return (num1 / num2) * 100 + '%';
};
